export default __webpack_public_path__ + "assets/credit-card-component.dc180d7c.svg";